module.exports = __webpack_public_path__ + "static/media/email-send-icon.f3d8f56b.svg";